import { render, staticRenderFns } from "./ConferenceDetailCard.vue?vue&type=template&id=6d3ec056&scoped=true"
import script from "./ConferenceDetailCard.vue?vue&type=script&lang=js"
export * from "./ConferenceDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ConferenceDetailCard.vue?vue&type=style&index=0&id=6d3ec056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ec056",
  null
  
)

export default component.exports